import { Box, Typography, TextField } from '@mui/material';
import useDebounce from '../../../hooks/useDebounce';
import React, { useState, useEffect } from 'react';
import Iconify from '../../Iconify'
import '../../../css/machines/machineReportFiltration.css';

const MachineReportFiltration = ({ handleResetFilters, fetchedReports, filteredReportsCount, machineReportFiltration, setMachineReportFiltration }) => {

    const [search, setSearch] = useState(machineReportFiltration.search);

    const debouncedSearch = useDebounce(search, 1000);

    useEffect(() => {
        setMachineReportFiltration((prev) => ({
            ...prev,
            search: debouncedSearch
        }));
    }, [debouncedSearch, setMachineReportFiltration]);

    const clearFilters = () => {
        setSearch('')
        handleResetFilters()
    }

    return (
            <Box className="machineReportFiltration_search_display_box">
                    <Box className='machineReportFiltration_search_box'>
                        <TextField
                            sx={{ width: '100%' }}
                            size="small"
                            value={search}
                            placeholder='Rechercher'
                            onChange={(e) => setSearch(e.target.value)}
                            variant="outlined"
                            InputProps={{
                                startAdornment: <Iconify icon={"bx:bx-search"} className='machineReportFiltration_search_icon' />,
                                sx: {
                                    backgroundColor: '#fff',
                                    height: '36px',
                                    fontFamily: 'Mulish',
                                    color: '#201E1E',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                },
                            }}
                        />
                        <Typography className='machineReportFiltration_clearAll' onClick={clearFilters}>Re-initialiser</Typography>
                    </Box>
                    <Typography className='machineReportFiltration_total_number'>{`${fetchedReports} / ${filteredReportsCount} résultats`}</Typography>
            </Box>
    )
}

export default MachineReportFiltration